import { Box, IconButton, makeStyles, TextField, useTheme } from '@material-ui/core'
import { AddOutlined, CancelOutlined } from '@material-ui/icons'
import clsx from 'clsx'
import React, { useEffect, useState } from 'react'
import { Fragment } from 'react'

import { MainButton } from '../..'
import { SubTitle, Title } from './Headers'

const useStyles = makeStyles((theme) => ({
	row: {
		width: '100%',
		display: 'flex',
		flexWrap: 'wrap',
		justifyContent: 'space-between',
		'& .MuiTextField-root, .MuiAutocomplete-root, .MuiFilledInput-root': {
			// width: 270,
			minWidth: 270
		},
		'& .MuiSvgIcon-root': {
			color: '#3B0275',
			fill: '#3B0275'
		}
	},
	input: {
		marginBottom: theme.spacing(2),
		width: '32%'
	}
}))

export const ListWithAddButton = ({
	title,
	subtitle,
	list = [], // list of elements with _id
	label,
	onChange,
	onAdd,
	onDelete,
	disabled = false,
	maxCharacters = 100,
	addButtonLabel = 'Add'
}) => {
	const classes = useStyles()
	const theme = useTheme()

	return (
		<Fragment>
			{title && <Title label={title} />}
			{subtitle && <SubTitle label={subtitle} />}
			<Box>
				{!disabled &&
					list.map((element, index) => (
						<Box key={'ListWithAddButton' + index} className={classes.row}>
							<TextField
								className={clsx([classes.input])}
								style={{ width: '95%' }}
								label={label}
								variant="filled"
								required
								value={element}
								onChange={(e, v) => {
									e.preventDefault()
									list[index] = e.target.value
									if (onChange) onChange(list)
								}}
								helperText={`${element.length || 0} / ${maxCharacters} Max Characters`}
								inputProps={{ maxLength: maxCharacters }}
							/>
							<Box style={{ width: '5%' }}>
								<IconButton
									style={{
										color: '#777679'
									}}
									onClick={() => {
										list.splice(index, 1)
										if (onDelete) onDelete(list)
									}}>
									<CancelOutlined style={{ fill: theme.palette.error.main }} />
								</IconButton>
							</Box>
						</Box>
					))}
				<MainButton
					label={addButtonLabel}
					disabled={disabled}
					onClick={() => {
						const perks = list || []
						perks.push('')
						if (onAdd) onAdd(perks)
					}}
					startIcon={<AddOutlined style={{ fill: theme.palette.secondary.main }} />}
				/>
			</Box>
		</Fragment>
	)
}
